import { Injectable, Injector } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { LanguageService } from './language';

const HOME_KEY = 'pageTitle.home';

/**
 * Заголовок вкладки браузера: в маршруте `title` — ключ перевода (pageTitle.*),
 * здесь он переводится на текущий язык и обновляется при смене языка.
 * Главная — полное название платформы, остальные страницы — «Страница — Bilload».
 */
@Injectable({ providedIn: 'root' })
export class I18nTitleStrategy extends TitleStrategy {
  private key = HOME_KEY;
  private languageService?: LanguageService;

  constructor(
    private readonly title: Title,
    private readonly injector: Injector
  ) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.key = this.buildTitle(snapshot) ?? HOME_KEY;
    this.apply();
  }

  /**
   * LanguageService берём лениво: Router создаёт TitleStrategy, а LanguageService → HttpClient →
   * authInterceptor → Router, и прямая инъекция в конструкторе дала бы циклическую зависимость.
   */
  private language(): LanguageService {
    if (!this.languageService) {
      this.languageService = this.injector.get(LanguageService);
      this.languageService.getTranslations().subscribe(() => this.apply());
    }
    return this.languageService;
  }

  private apply(): void {
    const value = this.language().translate(this.key);
    // Переводы ещё не загружены — оставляем заголовок из index.html
    if (!value || value === this.key) return;
    this.title.setTitle(this.key === HOME_KEY ? value : `${value} — Bilload`);
  }
}
